var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role !== "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role == "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-lg-12" },
              [
                _c("span", [_vm._v("Разрешить вносить/изменять данные с:")]),
                _vm._v(" "),
                _vm.loaded
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("formatDate")(_vm.settings.edit_date))
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("i", {
                  staticClass: "icon-fa icon-fa-edit",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.edit }
                }),
                _vm._v(" "),
                _vm.open
                  ? _c("datepicker", {
                      staticClass: "date",
                      attrs: {
                        "input-class": "form-control",
                        "monday-first": "",
                        inline: true,
                        language: _vm.ru,
                        placeholder: ""
                      },
                      on: { selected: _vm.onDateChange },
                      model: {
                        value: _vm.settings.edit_date,
                        callback: function($$v) {
                          _vm.$set(_vm.settings, "edit_date", $$v)
                        },
                        expression: "settings.edit_date"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Настройки")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-658928b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658928b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/Settings.vue
// module id = 1012
// module chunks = 0